import CMS from 'netlify-cms'
import 'netlify-cms/dist/cms.css'
import ArticlePreview from './previews/Article'
import LandingPreview from './previews/Landing'
import S3Thumbnails from './widgets/S3Thumbnails'
import QuotePicker from './widgets/QuotePicker'

CMS.registerPreviewStyle('/styles/root.css')
CMS.registerPreviewStyle('/styles/landing-page.css')
CMS.registerWidget('s3Thumbnails', S3Thumbnails)
CMS.registerWidget('quotePicker', QuotePicker)
CMS.registerPreviewTemplate('article', ArticlePreview)
CMS.registerPreviewTemplate('landing', LandingPreview)



// WEBPACK FOOTER //
// ./src/cms/cms.js